import { bindActionCreators } from 'redux';
import comActions from '../Actions/commonActions';
import { useDispatch, useSelector } from 'react-redux';

const useModal = () => {
    const dispatch = useDispatch();
    const commonActions = bindActionCreators(comActions, dispatch);
    const activeModal = useSelector((state) => state.CommonReducer.currentlyActiveModal);

    const openModal = (modalId) => {
        commonActions.activateModal(modalId);
    };

    const closeModal = () => {
        commonActions.activateModal(null);
        commonActions.hideAlert();
    };

    const isModalOpen = (modalId) => {
        return activeModal === modalId;
    };

    return {
        isModalOpen,
        openModal,
        closeModal,
    };
};

export default useModal;
